import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Space,
  Table,
  message,
  notification,
} from "antd";
import { InputFields, Notification } from "components/common";
import React, { useState } from "react";
import { DataFormField } from "types/models/input-field-type";
import { FIELD_TYPE } from "types/enums";
import Icons from "assets/icons";
import "./SaveNewBCD.scss";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { listExamination } from "api";
import { setAction } from "redux/reducer/examination";
import { EXAMINATION_ACTION_TYPE } from "types/enums/examination";
import { setListBCĐ } from "redux/reducer/residentialNurse";
import { columns } from "./config";
import { DataType } from "types/models";
const SaveNewBCD = (props) => {
  let dispatch = useAppDispatch();
  const { open, setOpen } = props;
  const dsChiDinh = useAppSelector((state) => state.listAssign.dsChiDinh);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
  const [selectedRows, setSelectedRows] = useState(null);
  const [form] = Form.useForm();
  const fields: DataFormField[] = [
    {
      label: "Tên bộ chỉ định",
      type: FIELD_TYPE.INPUT,
      name: "tenBoChiDinh",
      css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
      rules: [{ required: true, message: "Hãy nhập tên cho bộ chỉ định" }],
    },
    {
      label: "Ghi chú",
      name: "moTa",
      css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
      type: FIELD_TYPE.INPUT,
    },
  ];
  const getListDMBoChiDinh = async (params?: any) => {
    try {
      let response = await listExamination.getListDMBoChiDinh();
      dispatch(setListBCĐ(response.data));
    } catch (error) {
      console.log("🚀 ~ getListDMBoChiDinh ~ error:", error);
    }
  };
  const handleOk = async () => {
    form
      .validateFields()
      .then(async (values) => {
        const data = {
          tenBoChiDinh: values.tenBoChiDinh,
          moTa: values.moTa,
          dmDichVuDtos: selectedRows,
        };
        let response = await listExamination.postBCD(data);

        dispatch(
          setAction({
            actionType: EXAMINATION_ACTION_TYPE.ADDEDNEWBCD,
          })
        );
        getListDMBoChiDinh();
        handleCancel();
      })
      .catch((err) =>
        Notification("eror", "Thêm bộ chỉ định mới không thành công")
      );
  };
  const handleCancel = () => {
    form.resetFields();
    setOpen(false);
    setSelectedRows([]);
  };

  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      setSelectedRows(selectedRows);
      setSelectedRowKeys(selectedRowKeys);
    },
  };
  return (
    <Row className="save-new-bcd">
      <Modal
        title={"Lưu bộ chỉ định mới"}
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={false}
        width={1100}
        footer={[
          <Row justify={"end"}>
            <Button
              icon={<Icons.close />}
              onClick={handleCancel}
              style={{ marginRight: "5px" }}
            >
              Hủy
            </Button>
            <Button icon={<Icons.save />} type="primary" onClick={handleOk}>
              Lưu
            </Button>
          </Row>,
        ]}
      >
        <Row gutter={16}>
          <Col span={10}>
            <Form form={form} size="large">
              <Row gutter={[0, 16]}>
                <InputFields data={fields} />
              </Row>
            </Form>
          </Col>
          <Col span={14}>
            <Table
              bordered
              columns={columns}
              dataSource={
                dsChiDinh?.map((el, i) => ({
                  ...el,
                  key: el.id,
                  stt: i + 1,
                  chiDinhDaChon: el.tenDichVu,
                })) || []
              }
              pagination={false}
              rowSelection={{
                ...rowSelection,
              }}
            />
          </Col>
        </Row>
      </Modal>
    </Row>
  );
};

export default SaveNewBCD;
